import { OperationalParametric } from "./operationalParametric.model";
import { OperationalProvincia } from "./operationalProvincia.model";
import { PaisCliente } from "./paisCliente.model";
import { OperationalDepartamento } from "./operationalDepartamento.model";

export class Direccion {

  pais: OperationalParametric;
  provincia: OperationalProvincia;
  departamentoProvincia: OperationalDepartamento;
  direccion: string;
  numero: string;
  piso: string;
  departamento: string;
  codPostal: string;
  PaisCliente = new PaisCliente();

  constructor() {
    this.pais = new OperationalParametric();
    this.provincia = new OperationalProvincia(1);
    this.departamentoProvincia = new OperationalDepartamento(1);
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/direccion.model.ts